import React, {useEffect, useState, useRef} from "react";
import CheckoutSection from "../../components/HomePageComp/CheckoutSection/TestCheckout";
import UpdatedPublicCheckoutPage from "../../components/HomePageComp/CheckoutSection/CheckoutSection";
import BestPlans from "./BestPlans/BestPlans";
import axios from "axios";
import FundingSection from "../../components/HomePageComp/FundingSection/FundingSection";
import "./ProductPage.scss";

import {useDispatch, useSelector} from "react-redux";
import {fetchChallenges} from "../../Redux/ChallengeDataSlice";

const ProductPage = () => {
  // const {isLoading, apiData} = useFetch(`${baseUrl}v2/challenges/`);

  // const dispatch = useDispatch();

  // useEffect(() => {
  //   dispatch(fetchChallenges());
  // }, []);

  const {isLoading, challenges} = useSelector((state) => state.challengesData) || {};

  const [selectedPlanId, setSelectedPlanId] = useState(null);

  const checkoutPageRef = useRef(null);
  const planPageRef = useRef(null);

  // useEffect(() => {
  //   const fetchChallenges = async () => {
  //     try {
  //       const response = await axios.get("https://backend.alphacapitalgroup.uk/v2/challenges/");
  //       const {data} = response;
  //       setChallenges(data);
  //     } catch (err) {
  //       console.error("Error fetching challenges:", err);
  //     }
  //   };

  //   fetchChallenges();
  // }, []);

  const scrollToSection = (ref) => {
    ref?.current?.scrollIntoView({
      behavior: "smooth",
      block: "start",
    });
  };

  const handleMoreDetails = (id) => {
    setSelectedPlanId(id);
    scrollToSection(planPageRef);
  };

  const handleBuyPreset = (id) => {
    setSelectedPlanId(id);
    scrollToSection(checkoutPageRef);
  };

  const handleScrollToCheckout = (id) => {
    setSelectedPlanId(id);
    scrollToSection(checkoutPageRef);
  };

  return (
    <>
      <div className="productPageContainer">
        <div className="productPageWrapper">
          {/* BestPlans component */}
          <BestPlans
            challenges={challenges || []}
            onMoreDetails={handleMoreDetails}
            onBuyPreset={handleBuyPreset}
          />
          <div
            id="TestYourSkills"
            ref={planPageRef}
          >
            <FundingSection
              selectedPlanId={selectedPlanId}
              handleScrollToCheckout={handleScrollToCheckout}
              apiData={challenges}
              isLoading={isLoading}
            />
          </div>
          {/* UpdatedPublicCheckoutPage with ref for scrolling */}
          <div ref={checkoutPageRef}>
            <UpdatedPublicCheckoutPage
              challenges={challenges || []}
              selectedPlanId={selectedPlanId}
            />
          </div>{" "}
        </div>
      </div>
    </>
  );
};

export default ProductPage;
